export enum FeatureFlags {
	StudiesDeletable = "studies_deletable",
	SessionsRebuildable = "sessions_rebuildable",
	ExperimentalPanorama = "exp_pano"
}